export interface PricingRelevantBillingInfos {
  countryCode: string;
  billingInformationId: number | null;
}
